const inputFormat = {
  border: '1.05px solid #ff0000ab',
  boxShadow: 'inset 0px 0px 8px 0px rgba(255, 0, 0, 0.5)',
  color: '#ff0000ab'
}

export default inputFormat;
